import React from 'react';
import { ColumnsType } from 'antd/lib/table';
import { getI18n } from 'react-i18next';
import { Tag, Tooltip } from 'antd';
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ClockCircleOutlined,
  MinusCircleOutlined,
} from '@ant-design/icons';
import TableHeader from '~/pages/agent/components/agent/tableElements/TableHeader';
import styled from 'styled-components';

function resultCell(visibleColumns: any) {
  if (!visibleColumns.includes('result')) {
    return null;
  }
  return {
    title: <TableHeader title={getI18n().t('Result', { ns: 'sales' })} />,
    dataIndex: ['result'],
    key: 'result',
    render: (result: any, record: any) => <ResultDisplay result={result} record={record} />,
    width: 120,
  };
}

const ResultDisplay = ({ result, record }: { result?: string; record: any }) => {
  if (!result) return <Tag color="default">-</Tag>;

  const getResultConfig = (result: any) => {
    switch (result) {
      case 'Not Handled Yet':
        return {
          color: 'default',
          icon: <ClockCircleOutlined />,
          text: 'Not Handled',
        };

      case 'Merchant not Reachable':
        return {
          color: 'warning',
          icon: <MinusCircleOutlined />,
          text: 'Not Reachable',
        };

      case 'Continue with Self-Onboarding with Support':
        return {
          color: 'processing',
          icon: <CheckCircleOutlined />,
          text: 'With Support',
        };

      case 'Continue with Self-Onboarding without Support':
        return {
          color: 'success',
          icon: <CheckCircleOutlined />,
          text: 'Without Support',
        };

      case 'Close Lead & Log the Reason':
        return {
          color: 'error',
          icon: <CloseCircleOutlined />,
          text: 'Close Lead',
        };

      default:
        return {
          color: 'default',
          icon: null,
          text: result,
        };
    }
  };

  const config = getResultConfig(result);

  return (
    <Tooltip title={`Lead result: ${result}`}>
      <StyledTag color={config.color}>
        {config.icon && <IconWrapper>{config.icon}</IconWrapper>}
        {config.text}
      </StyledTag>
    </Tooltip>
  );
};

const StyledTag = styled(Tag)`
  display: flex;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  font-weight: 500;
  text-transform: capitalize;
`;

const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  font-size: 12px;
`;

export default resultCell;
